import { SUPPORTED_BANKS_FOR_LINKING } from "../constants/banks";

const normalize = (name: string) => name.toLowerCase().replace(/[^a-z]/g, "");

export const getBankMeta = (institutionName: string) => {
  return SUPPORTED_BANKS_FOR_LINKING.find(
    (bank) => normalize(bank.name) === normalize(institutionName)
  );
};
